import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function TestimonialsSection() {
  return <section className="py-24 bg-brand-dark relative" data-id="element-366">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-367">
        <FadeIn data-id="element-368">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-16 text-center uppercase tracking-tight" data-id="element-369">
            LO QUE DICEN LOS QUE YA LO APLICARON
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-370">
          {/* Testimonial 1 */}
          <FadeIn delay={0.1} direction="up" data-id="element-371">
            <div className="bg-zinc-900 border border-zinc-800 p-6 rounded-xl h-full flex flex-col" data-id="element-372">
              <div className="flex text-amber-400 mb-4 text-sm" data-id="element-373">★★★★★</div>
              <h4 className="text-white font-bold text-lg mb-3" data-id="element-374">
                "El Error E14 resuelto en 3 minutos"
              </h4>
              <p className="text-zinc-400 italic mb-6 flex-grow" data-id="element-375">
                "El Error E14 me apareció en la calle a las 8 de la mañana. Abrí
                el Tomo 1, busqué el código, seguí los pasos y en 3 minutos el
                monopatín andaba. Llegué al trabajo a tiempo. Sin el pack
                hubiera pedido un remis."
              </p>
              <div className="border-t border-zinc-800 pt-4" data-id="element-376">
                <p className="text-white font-bold" data-id="element-377">Martín G.</p>
                <p className="text-zinc-500 text-sm" data-id="element-378">
                  Usuario Xiaomi M365 · Buenos Aires, CABA
                </p>
              </div>
            </div>
          </FadeIn>

          {/* Testimonial 2 */}
          <FadeIn delay={0.2} direction="up" data-id="element-379">
            <div className="bg-zinc-900 border border-zinc-800 p-6 rounded-xl h-full flex flex-col" data-id="element-380">
              <div className="flex text-amber-400 mb-4 text-sm" data-id="element-381">★★★★★</div>
              <h4 className="text-white font-bold text-lg mb-3" data-id="element-382">
                "4 meses sin pinchar"
              </h4>
              <p className="text-zinc-400 italic mb-6 flex-grow" data-id="element-383">
                "Llevaba 2 años pinchando cada 3 semanas. El Tomo 2 me enseñó a
                cambiar la cámara yo solo y a inyectarle Slime preventivo. Llevo
                4 meses sin pinchar."
              </p>
              <div className="border-t border-zinc-800 pt-4" data-id="element-384">
                <p className="text-white font-bold" data-id="element-385">Diego F.</p>
                <p className="text-zinc-500 text-sm" data-id="element-386">
                  Usuario Segway Ninebot · Córdoba Capital
                </p>
              </div>
            </div>
          </FadeIn>

          {/* Testimonial 3 */}
          <FadeIn delay={0.3} direction="up" data-id="element-387">
            <div className="bg-zinc-900 border border-zinc-800 p-6 rounded-xl h-full flex flex-col" data-id="element-388">
              <div className="flex text-amber-400 mb-4 text-sm" data-id="element-389">★★★★★</div>
              <h4 className="text-white font-bold text-lg mb-3" data-id="element-390">
                "Me ahorré el cambio de controlador"
              </h4>
              <p className="text-zinc-400 italic mb-6 flex-grow" data-id="element-391">
                "Se me mojó el monopatín en una tormenta y no encendía. Seguí el
                Protocolo de Rescate del Tomo 3 paso a paso. 48 horas después
                encendió perfectamente. Me ahorré el cambio de controlador."
              </p>
              <div className="border-t border-zinc-800 pt-4" data-id="element-392">
                <p className="text-white font-bold" data-id="element-393">Lucía M.</p>
                <p className="text-zinc-500 text-sm" data-id="element-394">
                  Usuaria Xiaomi M365 Pro · Rosario, Santa Fe
                </p>
              </div>
            </div>
          </FadeIn>

          {/* Testimonial 4 */}
          <FadeIn delay={0.4} direction="up" data-id="element-395">
            <div className="bg-zinc-900 border border-zinc-800 p-6 rounded-xl h-full flex flex-col" data-id="element-396">
              <div className="flex text-amber-400 mb-4 text-sm" data-id="element-397">★★★★★</div>
              <h4 className="text-white font-bold text-lg mb-3" data-id="element-398">
                "Freno ajustado en 5 minutos"
              </h4>
              <p className="text-zinc-400 italic mb-6 flex-grow" data-id="element-399">
                "El freno se me puso blando de golpe. Sin el Tomo 4 hubiera ido
                al service. Con el Tomo 4 ajusté el cable en 5 minutos con una
                llave allen de $2.000."
              </p>
              <div className="border-t border-zinc-800 pt-4" data-id="element-400">
                <p className="text-white font-bold" data-id="element-401">Carlos R.</p>
                <p className="text-zinc-500 text-sm" data-id="element-402">
                  Usuario Genérico · Mendoza
                </p>
              </div>
            </div>
          </FadeIn>

          {/* Testimonial 5 */}
          <FadeIn delay={0.5} direction="up" data-id="element-403">
            <div className="bg-zinc-900 border border-zinc-800 p-6 rounded-xl h-full flex flex-col" data-id="element-404">
              <div className="flex text-amber-400 mb-4 text-sm" data-id="element-405">★★★★★</div>
              <h4 className="text-white font-bold text-lg mb-3" data-id="element-406">
                "Batería resucitada en 24 horas"
              </h4>
              <p className="text-zinc-400 italic mb-6 flex-grow" data-id="element-407">
                "Guardé el monopatín en invierno y en septiembre no arrancaba.
                El Protocolo de Resucitación del Tomo 5 lo recuperó en 24 horas.
                El service me había dicho que necesitaba batería nueva."
              </p>
              <div className="border-t border-zinc-800 pt-4" data-id="element-408">
                <p className="text-white font-bold" data-id="element-409">Valeria T.</p>
                <p className="text-zinc-500 text-sm" data-id="element-410">
                  Usuaria Smoot Volt · Tucumán
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}